/**
 * NotFoundPage — 404 catch-all page.
 */
import { Link } from "react-router-dom";
import { PublicLayout } from "../components/public-layout.js";

export function NotFoundPage() {
  return (
    <PublicLayout>
      <div className="error-page">
        <h1>Page not found</h1>
        <p>The page you are looking for does not exist.</p>
        <Link to="/" className="btn btn--primary">
          Go home
        </Link>
      </div>
    </PublicLayout>
  );
}
